import { AlertTriangle, X } from 'lucide-react';

const formatDate = (d) => {
    if (!d) return '';
    const [y, m, day] = d.split('-');
    return `${day}/${m}/${y}`;
};

export const ReportPhotoCheckDialog = ({ result, onCancel, onProceed, onOpenDay }) => {
    if (!result) return null;
    const { problems, checked } = result;

    return (
        <div data-testid="photo-check-dialog" className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={onCancel}>
            <div className="w-full max-w-lg bg-[#0A0A0A] border border-yellow-500/50 p-6 max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-start justify-between gap-3 mb-4">
                    <div className="flex items-center gap-3">
                        <AlertTriangle className="w-6 h-6 text-yellow-500 shrink-0" />
                        <div>
                            <h3 className="text-white font-semibold">Foto che non entreranno nel report</h3>
                            <p data-testid="photo-check-summary" className="text-white/60 text-sm">
                                {problems.length} su {checked} foto non possono essere inserite
                            </p>
                        </div>
                    </div>
                    <button type="button" data-testid="photo-check-close-btn" onClick={onCancel} className="text-white/50 hover:text-white">
                        <X className="w-5 h-5" />
                    </button>
                </div>
                <ul className="space-y-2 overflow-auto flex-1 mb-5" data-testid="photo-check-list">
                    {problems.map((p) => (
                        <li key={p.media_id} data-testid={`photo-check-item-${p.media_id}`}
                            className="border border-white/10 p-3 flex items-center justify-between gap-3">
                            <div className="min-w-0">
                                <p className="text-white text-sm truncate">{p.filename}</p>
                                <p className="text-white/50 text-xs">
                                    Giorno {formatDate(p.day_date)}{p.event_time ? ` · ore ${p.event_time}` : ''} · <span className="text-yellow-500">{p.reason}</span>
                                </p>
                            </div>
                            <button type="button" data-testid={`photo-check-open-day-${p.media_id}`} onClick={() => onOpenDay(p.day_id)}
                                className="text-xs text-[#00FF41] hover:underline shrink-0">
                                Apri giornata
                            </button>
                        </li>
                    ))}
                </ul>
                <p className="text-white/50 text-xs mb-4">Puoi ricaricare queste foto nella giornata (es. riesportandole in JPG) oppure generare il report senza di esse.</p>
                <div className="flex justify-end gap-3">
                    <button type="button" data-testid="photo-check-cancel-btn" onClick={onCancel}
                        className="px-4 py-2 border border-white/20 text-white text-sm hover:border-white/40 transition-colors">
                        Annulla
                    </button>
                    <button type="button" data-testid="photo-check-proceed-btn" onClick={onProceed}
                        className="px-4 py-2 bg-[#00FF41] text-black text-sm font-medium hover:bg-[#00CC33] transition-colors">
                        Genera comunque
                    </button>
                </div>
            </div>
        </div>
    );
};
